import React, { useEffect } from "react";
import './ServicesPage.scss';
import $ from 'jquery';
import { useState } from "react";
import { Helmet } from "react-helmet";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"

// images
import Review from '../../Images/Review.png'
import next from '../../Images/next.png'
import telephone from '../../Images/telephone.png'


import GarageImg1 from '../../Images/GarageImg1.jpg'
import GarageImg2 from '../../Images/GarageImg2.jpg'
import GarageImg3 from '../../Images/GarageImg33.jpg'
import GarageImg4 from '../../Images/GarageImg4.jpg'
import GarageImg6 from '../../Images/GarageImg6.jpg'
import GarageImg7 from '../../Images/GarageImg7.jpg'
import GarageImg8 from '../../Images/GarageImg8.jpg'
import GarageImg9 from '../../Images/GarageImg9.jpg'
import AreaData from './AreaData'

import clock from '../../Images/clock.png'
import computer from '../../Images/computer.png'
import books from '../../Images/books.png'
import { useLocation } from "react-router-dom";
import parse from 'html-react-parser'

export default function ServicesPage({ navigateTo, FaqList, Blogs }) {
    const [Content, setContent] = useState(null);

    function readingTime(S) {
        const text = S.Text;
        const wpm = 225;
        const words = text.trim().split(/\s+/).length;
        const time = Math.ceil(words / wpm);
        return time
    }

    const getSpecificNumberFaq = () => {
        const number = Math.random() * FaqList.length
        if (number <= (FaqList.length - 3) && number > 0) {
            return Math.floor(number)
        } else {
            return getSpecificNumberFaq()
        }
    }
    const [getNumberFaq, setgetNumberFaq] = useState(getSpecificNumberFaq());
    const getSpecificNumberBlog = () => {
        const number = Math.random() * Blogs.length
        if (number <= (Blogs.length - 3) && number > 0) {
            return Math.floor(number)
        } else {
            return getSpecificNumberBlog()
        }
    }
    const [getNumberBlog, setgetNumberBlog] = useState(getSpecificNumberBlog());

    const location = useLocation().pathname

    useEffect(() => {
        setContent(AreaData.find(a => a.Path == location));
        console.log(Content);
    }, []);

    return (
        <div className="ServicesPage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>{Content ? Content.Des + " " + "| 314-350-6643" : "Garage Door & Repair 314-350-6643 | Best Garage Door"}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content={`${Content ? Content.Des + " " + "| 314-350-6643" : "Garage Door & Repair 314-350-6643 | Best Garage Door"}`} data-react-helmet="true" />
                <meta name="og:title" property="og:title" content={`${Content ? Content.Des + " " + "| 314-350-6643" : "Garage Door & Repair 314-350-6643 | Best Garage Door"}`} data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.bhogaragedoor.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Garage Door offers professional Garage Door, inspection, repair, and maintenance services in. Ensure your Garage Door operates safely and efficiently with our expert services. Contact us today!" data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content={`${"Garage Door offers professional Garage Door, inspection, repair, and maintenance services in. Ensure your Garage Door operates safely and efficiently with our expert services. Contact us today!"}`} data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content={`${Content ? Content.Des + " " + "| 314-350-6643" : "Garage Door & Repair 314-350-6643 | Best Garage Door"}`} data-react-helmet="true" />
                <meta name="keywords" content="Garage Door, Garage DoorInspection, Garage DoorInspection, Garage Door Inspection, Garage Door Repair, Garage Door, Garage Door Maintenance, Garage Door Maintenance, Dryer Vent Repair, Garage DoorInspection, Garage Door Inspection, Garage Door Repair, Garage Door, Garage Door Maintenance, Garage Door Maintenance, Dryer Vent Repair, Garage Door Services, Garage Door Service, Garage DoorInspection, Garage Door Inspection, Garage Door Repair, Garage Door, Garage Door Maintenance, Garage Door Maintenance, Dryer Vent Repair, Garage DoorInsulation, Garage DoorInstallation, Garage DoorLiner Repair, Garage DoorPointing, Garage DoorRain Cap Installation, Garage Door repair, Garage DoorCrown Repair, Garage DoorRestoration, Garage DoorFlue Installation, Garage DoorFlue Repair, ​Garage DoorConstruction, Garage DoorVent Installation, Garage DoorFlashing, Flexible Garage DoorLiner Installation, Garage DoorDamper Repair, Garage DoorCap Repair, Garage Door Insulation, Garage Door Installation, Garage Door Liner Repair, Garage Door Pointing, Garage Door Rain Cap Installation, Garage Door Repair, Garage Door Crown Repair, Garage Door Restoration, Garage Door Flue Installation, Garage Door Flue Repair, FGarage Door Construction, Garage Door Vent Installation, Garage Door Flashing, Flexible Garage Door Liner Installation, Garage Door Damper Repair, Garage Door Cap" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}

            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>{Content ? Content.Des : "Garage Door"}</h1>
                    <h2>Garage Door Near Me </h2>
                </div>
                <div className="MainBannerRight">
                    <img src={GarageImg6} alt={Content ? Content.Des : "Expert Garage Door Services | Garage Door"} />
                    <div className="MainBannerRightBubble1"></div>
                    <div className="MainBannerRightBubble2"></div>
                </div>
            </div>
            <div className="WebSiteBanner">
                {Content ? parse(Content.Content) : null}
                <a href=""></a>
            </div>
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBox">
                    <h2>Garage Door ServiceS</h2>
                    <div className="MainBanner2TopBoxMenu">
                        <a href="/service/Garage-Door-Repair" className="MainBanner2TopBoxBox">
                            <h3>Garage Door Repair</h3>
                        </a>
                        <a href="/service/Garage-Door-Services" className="MainBanner2TopBoxBox">
                            <h3>Garage Door Services</h3>
                        </a>
                        <a href="/service/Garage-Door-Broken-Spring" className="MainBanner2TopBoxBox">
                            <h3>Garage Door Broken Spring</h3>
                        </a>
                        <a href="/service/Garage-Door-Opener-Repair" className="MainBanner2TopBoxBox">
                            <h3>Garage Door Opener</h3>
                        </a>
                    </div>
                </div>
            </div>
            <div className="MainBannerReviews">
                <div className="MainBannerReviewsHeader">
                    <h1>Proudly recognized as "#1 Garage Door Company" by industry experts.</h1>
                </div>
                <div className="MainBannerReviewsMenu">
                    <div className="MainBannerReviewsMenuBox">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Yahoo%21_Finance_logo_2021.png/320px-Yahoo%21_Finance_logo_2021.png" alt="Expert Garage Door Services | Garage Door | " />
                    </div>
                    <div className="MainBannerReviewsMenuBox">
                        <img src="https://cdn.worldvectorlogo.com/logos/marketwatch-logo.svg" alt={Content ? Content.Des : "Expert Garage Door Services | Garage Door"} />
                    </div>
                    <div className="MainBannerReviewsMenuBox">
                        <img src="https://1000logos.net/wp-content/uploads/2024/02/Business-Insider-Logo.png" alt="Expert Garage Door Services | Garage Door | " />
                    </div>
                    <div className="MainBannerReviewsMenuBox">
                        <img src="https://1000logos.net/wp-content/uploads/2016/10/Associated-Press-logo.png" alt="Expert Garage Door Services | Garage Door | " />
                    </div>
                    <div className="MainBannerReviewsMenuBox">
                        <img src="https://1000logos.net/wp-content/uploads/2022/05/Benzinga-Logo.png" alt="Expert Garage Door Services | Garage Door | " />
                    </div>
                    <div className="MainBannerReviewsMenuBox">
                        <img src="https://www.iadea.com/wp-content/uploads/2018/10/digital-journal-logo.png" alt="Expert Garage Door Services | Garage Door | " />
                    </div>
                </div>
            </div>
            <div className="MainBanner2">
                <div className="MainBanner2TopTop">
                    <div className="MainBanner2TopTopLeft">
                        <img src={GarageImg8} alt="Expert Garage Door Services | Garage Door | Expert Garage Door Services" />
                    </div>
                    <div className="MainBanner2TopTopRight">
                        <div className="MainBanner2TopBox">
                            <h2>Expert Garage Door Services</h2>
                            <h3>Ensure your home’s security and efficiency with our professional Garage Door services.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>Dependable Garage Door Inspections & Repairs</h2>
                            <h3>Rely on our expert technicians to thoroughly inspect and repair your Garage Door.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>Premium Garage Door Maintenance</h2>
                            <h3>Prevent issues and extend the life of your Garage Door system with our top-quality maintenance services.</h3>
                        </div>
                    </div>
                </div>

                {/* Title */}
                <a href="tel:314-350-6643">CALL NOW 314-350-6643</a>
                <h1>Garage Door Repair Near Me</h1>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <h2>Garage Door Repair Services</h2>
                        <h3>
                            A malfunctioning Garage Door can disrupt your daily routine and compromise the security of your home. Our expert Garage Door repair services are designed to address any issue quickly and effectively. Whether it’s a broken spring, a faulty opener, or a door that’s off track, our skilled technicians have the experience and tools to get your Garage Door back in top condition.
                            <br />
                            <br />
                            We understand the urgency of Garage Door problems, which is why we offer prompt, same-day service for most repairs. Our team uses high-quality replacement parts to ensure lasting results, so you won’t have to worry about recurring issues. We also provide a thorough inspection during every repair to identify any underlying problems that could cause future headaches.
                            <br />
                            <br />

                            Safety is our top priority. A malfunctioning Garage Door can be dangerous, especially if it involves broken springs or cables. Trust our professionals to handle these repairs safely and efficiently, restoring your peace of mind.
                            <br />
                            <br />

                            <br />
                            Don’t let a faulty Garage Door disrupt your life. Contact us today to schedule a repair, and let our experts take care of your Garage Door needs with the professionalism and attention to detail you deserve.
                        </h3>
                        <a href="/service/Garage-Door-Repair">Learn More</a>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <h2>Comprehensive Garage Door Services</h2>
                        <h3>
                            Your Garage Door is a crucial part of your home’s functionality and security, and it deserves expert care. Our comprehensive Garage Door services cover everything you need to keep your door operating smoothly and reliably. From installation and repair to routine maintenance and emergency services, we’ve got you covered.
                            <br />
                            <br />
                            Installation: Whether you’re building a new home or replacing an old Garage Door, our professional installation services ensure a perfect fit and flawless operation. We offer a wide selection of high-quality doors to match your style and budget.
                            <br />
                            <br />
                            Repair: When your Garage Door isn’t working as it should, our skilled technicians are ready to diagnose and fix the problem. We handle everything from broken springs and cables to malfunctioning openers, using top-grade parts to ensure lasting repairs.
                            <br />
                            <br />
                            Maintenance: Regular maintenance is key to extending the life of your Garage Door and preventing costly breakdowns. Our maintenance services include thorough inspections, lubrication of moving parts, and adjustments to keep your door running smoothly.
                            <br />
                            <br />
                            Emergency Services: Garage Door issues can happen at any time, which is why we offer prompt emergency services. Whether it’s late at night or during the weekend, you can count on us to respond quickly and resolve the problem.
                            <br />
                            <br />
                            Trust us to provide the expert Garage Door services you need to keep your home safe, secure, and efficient.
                        </h3>
                        <a href="/service/Garage-Door-Services">Learn More</a>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <h2>Garage Door Opener Services</h2>
                        <h3>
                            The Garage Door opener is the unsung hero of your Garage Door system, providing the convenience of smooth, automatic operation at the push of a button. When your Garage Door opener malfunctions, it can be a major hassle, leaving you stranded outside or unable to securely close your garage. That’s where our expert Garage Door opener services come in.
                            <br />
                            <br />
                            Serving we specialize in the repair, replacement, and installation of all types of Garage Door openers. Whether your opener is making strange noises, struggling to lift the door, or has stopped working altogether, our skilled technicians can diagnose the issue and provide a quick and effective solution.
                            <br />
                            <br />
                            We work with top-quality openers from leading brands, ensuring you get a reliable, durable product that meets your needs. If your current opener is outdated or beyond repair, we can help you choose and install a new system with advanced features like smartphone connectivity, battery backup, and enhanced security options.
                            <br />
                            <br />
                            Our goal is to restore the convenience and security of your garage with minimal disruption to your daily routine. With our prompt service and attention to detail, you can trust us to get your Garage Door opener working perfectly again in no time.
                            <br />
                            <br />
                            Contact us today to schedule a service appointment and experience the difference that professional Garage Door opener services can make.
                        </h3>
                        <a href="/service/Garage-Door-Opener-Repair">Learn More</a>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <h2>Garage Door Broken Spring Repair</h2>
                        <h3>
                            A broken Garage Door spring is one of the most common and frustrating issues homeowners face. The springs play a crucial role in lifting and lowering your Garage Door, so when they break, your door becomes heavy, difficult to operate, or completely inoperable. This not only causes inconvenience but also poses a significant safety risk.
                            <br />
                            <br />
                            Our expert technicians specialize in repairing and replacing broken Garage Door springs quickly and safely. We understand the urgency of a broken spring, and that’s why we offer prompt, same-day service to get your Garage Door back in working order as soon as possible.
                            <br />
                            <br />
                            When you choose our service, you can trust that we’ll use high-quality, durable springs that are suited to your specific Garage Door. Our team carefully measures and selects the appropriate springs to ensure smooth, balanced operation, reducing the strain on your Garage Door system and extending its lifespan.
                            <br />
                            <br />
                            Attempting to fix a broken spring yourself can be dangerous due to the high tension in the springs. Leave it to our trained professionals who have the right tools and experience to handle the repair safely and effectively.
                            <br />
                            <br />
                            Don’t let a broken Garage Door spring disrupt your day—contact us today for fast, reliable service that restores your Garage Door’s functionality and keeps your home secure.
                        </h3>
                        <a href="/service/Garage-Door-Broken-Spring">Learn More</a>
                    </div>
                </div>
            </div>
            <div className="MainBanner4">
                <div className="MainBanner4Left">
                    <img src={GarageImg4} alt="Expert Garage Door Services | Garage Door | Garage Door" />
                    <div className="MainBanner4LeftBubble1"></div>
                    <div className="MainBanner4LeftBubble2"></div>
                </div>
                <div className="MainBanner4Right">
                    <h1>OUR OUR SERVICES</h1>
                    <h2>At  Garage Door, we offer comprehensive Garage Door Services including Repair, inspection, repair, and maintenance. Our certified technicians ensure your Garage Door is safe, efficient, and in top condition. We use high-quality materials and state-of-the-art equipment to deliver exceptional results, providing peace of mind and enhancing your home's safety and comfort.</h2>
                    <div className="MainBanner4RightBenefits">
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Broken-Spring">Garage Door Broken Spring</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Spring-Repair">Garage Door Spring Repair</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Broken-Rollers">Garage Door Broken Rollers</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Broken-Cables">Garage Door Broken Cables</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Broken-Hinges">Garage Door Broken Hinges</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Broken-Drums">Garage Door Broken Drums</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Off-Track">Garage Door Off Track</a>
                        <a className="Header1BoxMenuBox" href="/service/Damage-Garage-Door-Section">Damage Garage Door Section</a>
                        <a className="Header1BoxMenuBox" href="/service/New-Garage-Door-Installation">New Garage Door Installation</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Wont-Open-Or-Close">Garage Door Opener Won't Open Or Close</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Remote-Is-Not-Working">Garage Door Opener Remote Is Not Working</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Keypad-Is-Not-Working">Garage Door Opener Keypad Is Not Working</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Maintenance">Garage Door Maintenance</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Installation">Garage Door Installation</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Stripped-Gear">Garage Door Opener Stripped Gear</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Installation">Garage Door Opener Installation</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Repair">Garage Door Opener Repair</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Repair">Garage Door Repair</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Services">Garage Door Services</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Near-me">Garage Door Near me</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Spring-Replacement">Garage Door Spring Replacement</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Replacement">Garage Door Replacement</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Chain-Repair">Garage Door Opener Chain Repair</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Opener-Belt-Repair">Garage Door Opener Belt Repair</a>
                        <a className="Header1BoxMenuBox" href="/service/Garage-Door-Residential">Garage Door Residential</a>
                        <a className="Header1BoxMenuBox" href="/service/Commercial-Garage-Door">Commercial Garage Door</a>
                        <a className="Header1BoxMenuBox" href="/service/Residential-Garage-Doors">Residential Garage Doors</a>
                    </div>
                </div>
            </div>
            <div className="MainBanner5">
                <div className="MainBanner5Left">
                    <h1>How to get in touch with Garage Door Services ?</h1>
                    <div className="MainBanner5LeftBox">
                        <h2>1</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Call us.</h3>
                            <h4>Contact our expert team by calling or visiting our website to book Garage Door Services.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>2</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Provide some information.</h3>
                            <h4>Provide your address and specific details to our Garage Door professionals, including any unique aspects of your home that might affect the service.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>3</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>To know your situation more.</h3>
                            <h4>Share photos of your Garage Doorto help us understand its current condition and accurately estimate the service needed.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>4</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Date and Time.</h3>
                            <h4>Discuss the urgency of your service needs and agree on a tentative arrival date for our team.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>5</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Our team will do the best.</h3>
                            <h4>Our local service provider will determine the cost based on our standard pricing.</h4>
                        </div>
                    </div>
                    <a href="tel:314-350-6643">CALL NOW 314-350-6643</a>
                </div>
                <div className="MainBanner5Right">
                    <img alt={Content ? Content.Des : "Expert Garage Door Services | Garage Door"} src={GarageImg2} />
                    <div className="MainBanner5RightBubble1"></div>
                    <div className="MainBanner5RightBubble2"></div>
                </div>

            </div>
            <div className="MainBanner6">
                <h1>Trusted Mobile and Safe Service</h1>
                <div className="MainBanner6List">
                    <div className="MainBanner6TopBox">
                        <h2>Our Mission</h2>
                        <h3>Our mission is to connect you with the leading experts in Garage Door services in. By leveraging the latest technology and specialized expertise, we deliver efficient, top-quality care for your Garage Door, ensuring your home remains secure and functional.</h3>
                    </div>
                    <div className="MainBanner6TopBox">
                        <h2>Our Goals</h2>
                        <h3>Our professionals are part of a premier network dedicated to excellence in every aspect of Garage Door services. We emphasize collaboration, bringing together the best talent and resources to handle even the most complex Garage Door challenges with efficiency and precision.</h3>
                    </div>
                    <div className="MainBanner6TopBox">
                        <h2>Our Values</h2>
                        <h3>Our local service providers in prioritize safety for you, your family, pets, and neighbors while maintaining a commitment to environmental responsibility. We also uphold values of respect and kindness in every interaction, ensuring a positive experience from start to finish.</h3>
                    </div>
                </div>
            </div>
            <div className="MainBanner6">
                <h1>Real Testimonials from Our Valued Clients</h1>
                <h2>Garage Services delivered exceptional Garage Door repair and inspection services. The technician arrived on time, was highly professional, and conducted a thorough job. They explained the entire process clearly and ensured everything was in perfect order before leaving. I highly recommend Garage Services for their outstanding customer care and expertise. My Garage Door is now operating smoothly and securely, thanks to their top-notch work!</h2>
                <h3>5 stars company 🌟 🌟 🌟 🌟 🌟</h3>
            </div>
            <div className="BlogsListFaq">
                <div className="BlogsListFaqHead">
                    <h1>Frequently asked questions</h1>
                    <a href="/faq">View All</a>
                </div>
                <div className="BlogsListFaqList">
                    {FaqList.slice(getNumberFaq, (getNumberFaq + 5)).map((A, index) =>
                        <article key={index} className="FaqListBox">
                            <a href={`/faq/${A.questionPath.replace(/ /g, "_") + "_" + (A.faqId - 1)}`} >
                                <h1>{A.question}</h1>
                                {/* <h2>{A.answer.slice(0, 50 - 1) + "…"}</h2> */}
                                <h3><span> {A.category}</span></h3>
                            </a>
                        </article>

                    )}
                </div>
            </div>
            <div className="BlogsListReview">
                <div className="BlogsListReviewHead">
                    <h1>Related Articles</h1>
                    <a href="/blog">View All</a>
                </div>
                <div className="BlogsListReviewList">
                    {Blogs.slice(getNumberBlog, (getNumberBlog + 3)).map((A, index) =>

                        <a href={`/blog/${A.BlogPath.replace(/ /g, "_") + "_" + (A.BlogId - 1)}`} key={index} className="BlogsListReviewBox" >
                            <article>
                                <div className="BlogsListReviewBoxLeft">
                                    <img src={A.Photos} alt={A.BlogPath} />
                                </div>
                                <div className="BlogsListReviewBoxRight">
                                    <h1>{A.Title}</h1>
                                    <span>
                                        <h5>{readingTime(A)} MIN READ</h5>
                                        <h4>{A.Date}</h4>
                                    </span>
                                </div>
                            </article>
                        </a>
                    )}
                </div>
            </div>
            <div className="MainBanner7">
                <div className="MainBanner7Left">
                    <h1>The Importance of Professional Garage Door Services in</h1>
                    <h2>Keeping your Garage Doorclean and well-maintained is essential for the safety and efficiency of your Garage Door or stove. In, regular Garage Dooring is a critical task that ensures your Garage Dooroperates smoothly and reduces the risk of fire hazards. Here’s why professional Garage Door services are vital and what you can expect from the process.</h2>
                    <h2>
                        {/* (888) 269-4246 */}
                        <br />
                        Monday – Friday
                        <br />
                        8:00 a.m. – 8:00 p.m. ET
                    </h2>
                </div>
                <div className="MainBanner7Right">
                    <img src={GarageImg1} alt="Expert Garage Door Services | Garage Door | " />
                    <div className="MainBanner7RightBubble1"></div>
                    <div className="MainBanner7RightBubble2"></div>
                </div>
            </div>
            <NavigatorPath />
        </div>
    )
}

